import React from "react";
import RemoveIcon from "@mui/icons-material/Remove";
import { IoIosArrowRoundForward } from "react-icons/io";
import defaultIcon from "../../assets/image/defaultIcon.svg";
import { isDarkColor } from "./ColorOptions";

const QuickChatPreview = ({
  layout = "image-right",
  message = "Chat with us",
  backgroundColor = "#E9EBED",
  imageSrc,
}) => {
  const previewImage = imageSrc || defaultIcon;
  const showText = layout !== "custom-image";
  const showImage = layout !== "text-only";
  const iconOnDark = isDarkColor(backgroundColor);

  const renderBadgeContent = () => {
    const textEl = showText ? (
      <span className="quickChatPreviewBadgeText">
        {message || "Chat with us"}
      </span>
    ) : null;

    const imageEl = showImage ? (
      <span className="quickChatPreviewBadgeImage">
        <img src={previewImage} alt="" />
      </span>
    ) : null;

    if (layout === "image-left") {
      return (
        <>
          {imageEl}
          {textEl}
        </>
      );
    }

    if (layout === "custom-image") {
      return imageEl;
    }

    if (layout === "text-only") {
      return textEl;
    }

    return (
      <>
        {textEl}
        {imageEl}
      </>
    );
  };

  return (
    <div
      className={`quickChatPreview${iconOnDark ? " quickChatPreview--onDark" : ""}`}
    >
      <div className="quickChatPreviewWindow">
        <div className="quickChatPreviewHeader" style={{ backgroundColor }}>
          <span>convobird chat</span>
          {/* <RemoveIcon className="quickChatPreviewMinimize" /> */}
        </div>

        <div
          className={`quickChatPreviewBadge quickChatPreviewBadge--${layout}`}
          style={{ backgroundColor }}
        >
          {renderBadgeContent()}
        </div>

        <div className="quickChatPreviewInput">
          <input
            type="text"
            placeholder="Type your message here"
            style={{
              border: "none",
              outline: "none",
              backgroundColor: "transparent",
            }}
          />
          <IoIosArrowRoundForward className="quickChatPreviewSend" />
        </div>
      </div>
    </div>
  );
};

export default QuickChatPreview;
